module.exports = __webpack_public_path__ + "static/media/Mobile-App.7838ffed.jpg";